export const GROUP_ACCOUNT_TYPES = {
  FAMILY: 'FAMILY',
  BUSINESS: 'BUSINESS',
  PREMIUM: 'PREMIUM',
};

export const COOKIE_NAMES = {
  COOKIE_REFRESH_TOKEN: 'refreshToken',
  COOKIE_ACCESS_TOKEN: 'accessToken',
  COOKIE_EXPIRES_IN: 'expiresIn',
};

/** localStorage key used to broadcast logout to other tabs of the same browser (via the `storage` event). */
export const LOGOUT_BROADCAST_KEY = 'pingpad_logout_broadcast';

export const BILLING_CYCLES = {
  MONTHLY: 1,
  ANNUAL: 2,
};

export const BUSINESS_STATUS = {
  OPEN: 'Open',
  CLOSED: 'Closed',
  UNKNOWN: 'Unknown',
};

/** Default quota limits per service plan. Keys match ServiceLevel enum values ('Free', 'Basic', 'Standard', 'Premium'). */
export const QUOTA_DEFAULTS = {
  Free: { maxExtensions: 100, maxRingGroupMembers: 5 },
  Basic: { maxExtensions: 1000, maxRingGroupMembers: 5 },
  Standard: { maxExtensions: 1000, maxRingGroupMembers: 5 },
  Premium: { maxExtensions: 1000, maxRingGroupMembers: undefined },
};

/**
 * Endpoints come from CRA env files: .env.development (npm start / npm run build:dev),
 * .env.production (npm run build), with per-developer overrides in .env.local.
 */
const requiredEnv = (name) => {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Missing required env var ${name}. Define it in .env.development / .env.production (or .env.local).`);
  }
  return value;
};

export const USER_API_ENDPOINT = requiredEnv('REACT_APP_USER_API_ENDPOINT');
export const GROUP_API_ENDPOINT = requiredEnv('REACT_APP_GROUP_API_ENDPOINT');
export const CALL_API_ENDPOINT = requiredEnv('REACT_APP_CALL_API_ENDPOINT');
export const FILE_API_ENDPOINT = requiredEnv('REACT_APP_FILE_API_ENDPOINT');
export const PAYMENT_API_ENDPOINT = requiredEnv('REACT_APP_PAYMENT_API_ENDPOINT');
export const ACCESS_CONTROL_API_ENDPOINT = requiredEnv('REACT_APP_ACCESS_CONTROL_API_ENDPOINT');

export const CALL_SOCKET_URL = requiredEnv('REACT_APP_CALL_SOCKET_URL');

/** Chunk loading error handling - used for auto-reload after deployments */
export const CHUNK_ERROR_KEY = 'chunkErrorReloadAttempt';
export const CHUNK_ERROR_COOLDOWN_MS = 5000;

/** Notification key for app update available toast */
export const UPDATE_NOTIFICATION_KEY = 'app-update-available';
